import dinamoLogo from '../../assets/images/dinamo.svg'
import tectrolLogo from '../../assets/images/tectrol.svg'

export function getLogoByDomain(): string {
    if (window.location.hostname.includes('tectrolnet')) return tectrolLogo
    return dinamoLogo // fallback: dinamoautomacao, localhost, qualquer outro
}
